export default "__VITE_ASSET__Bv8R0XvC__"